import { createSelector } from '@reduxjs/toolkit';
import { chain } from 'lodash';

import { oneBoxV3Api } from '~/api/oneBoxV3';
import { TOneBoxV3GetInternetResourcesPayload } from '~/api/oneBoxV3/oneBoxV3.type';
import { RootState } from '~/store';

export const getterInternetResourceFilter = createSelector(
  (state: RootState) => state.internetResource.searchCondition,
  ({
    category,
    years,
    eduCodes,
    subjects,
    grades,
    fuzzySearch,
    fuzzySearchFields,
    dateFrom,
    dateTo,
    isLaunch,
    page,
    pageSize,
    sort,
  }) => ({
    category,
    years,
    eduCodes,
    subjects,
    grades,
    fuzzySearch,
    fuzzySearchFields,
    dateFrom,
    dateTo,
    isLaunch,
    pagination: {
      pageSize,
      page,
      sort,
    },
  }),
);

export const getterAdminInternetResourcesPayload = createSelector(
  (state: RootState) => state.internetResource.searchCondition,
  ({
    category,
    years,
    eduCodes,
    subjects,
    grades,
    fuzzySearch,
    fuzzySearchFields,
    isLaunch,
    page,
    pageSize,
  }) => {
    return {
      search: {
        ...(category !== 'all' && category && { category: [category] }),
        ...(years !== 'all' && years && { years }),
        ...(eduCodes !== 'all' && eduCodes && { eduCodes }),
        ...(subjects !== 'all' && subjects && { subjects }),
        ...(grades !== 'all' && grades && { grades }),
      },
      ...(fuzzySearch && { fuzzySearch }),
      ...(fuzzySearchFields && fuzzySearchFields[0] && { fuzzySearchFields }),
      isLaunch,
      pagination: {
        page,
        pageSize,
        sort: null,
      },
    };
  },
);

export const getterInternetResources = createSelector(
  [
    (state: RootState) => state.internetResource.resources,
    (state, params: TOneBoxV3GetInternetResourcesPayload) =>
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      oneBoxV3Api.endpoints.getInternetResources.select(params)(state)?.data,
  ],
  (initialData, resourceData) => {
    if (
      resourceData &&
      resourceData.data &&
      resourceData.data.data.length > 0
    ) {
      return {
        resources: resourceData.data.data,
        totalResourcesCount: resourceData.data.totalAmount,
      };
    }
    return {
      resources: initialData,
      totalResourcesCount: 0,
    };
  },
);

export const getterInternetDownloadList = createSelector(
  getterInternetResources,
  ({ resources }) =>
    chain(resources)
      .map(
        ({
          category,
          years,
          eduCodes,
          subjects,
          grades,
          resources1,
          resources2,
          urlName,
          url,
        }) => {
          return {
            category,
            years,
            eduCodes,
            subjects,
            grades,
            resources1,
            resources2,
            urlName,
            url,
          };
        },
      )
      .value(),
);

export const getterInternetResourcesPayload = createSelector(
  (state: RootState) => state.internetResource.searchCondition,
  ({
    category,
    years,
    eduCodes,
    subjects,
    grades,
    fuzzySearch,
    page,
    pageSize,
    resources2,
  }) => {
    return {
      search: {
        ...(category !== 'all' && category && { category: [category] }),
        ...(years !== 'all' && years && { years }),
        ...(eduCodes !== 'all' && eduCodes && { eduCodes }),
        ...(subjects !== 'all' && subjects && { subjects }),
        ...(grades !== 'all' && grades && { grades }),
        ...(resources2 !== 'all' && resources2 && { resources2 }),
      },
      ...(fuzzySearch && { fuzzySearch }),
      isLaunch: true,
      pagination: {
        page,
        pageSize,
        sort: null,
      },
    };
  },
);
